import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CashbackCreation from 'features/cashback/view/desktop/CashbackCreation';

const CashbackModule = (
  <Route key="/creative/cashback-creation" path="/creative/cashback-creation">
    <Switch>
      <Route key="/creative/cashback-creation" path="/creative/cashback-creation" component={CashbackCreation} />
    </Switch>
  </Route>
);

export default CashbackModule;

